export default "__VITE_ASSET__YA8omMZJ__"